<template>
  <a v-if="applicationAction" :href="applicationAction.href" class="dropdown-item"  :key="option.id" :target="setTarget(option.target)">
    <i :class="applicationAction.icon"></i>
    <span class="ml-4">{{ option.translation.name }}</span>
  </a>
  <a v-else-if="option.action === 'dashboard' && (user && !publicUser)" href="/app/dashboard" class="dropdown-item d-flex align-items-center" :key="option.id" :target="setTarget(option.target)">
    <i class="ni ni-collection"></i>
    <span class="ml-4">{{ option.translation.name }}</span>
  </a>
  <a v-else-if="option.action !== 'dashboard'" :href="option.url" class="dropdown-item" :key="option.id" :target="setTarget(option.target)">
    <span class="ml-4">{{ option.translation.name }}</span>
  </a>
</template>

<script>

export default {
  name: "DrawerCustomOption",
  props: {
    option: Object,
    user: {
      type: Object,
      required: false,
    },
    publicUser: {
      type: [Boolean, Number],
    }
  },
  computed: {
    color() {
      return this.$store.getters.COLOR;
    },
    applicationAction() {
      const actions = {
        plans: {
          href: '/plans',
          icon: this.option.icon,
        },
        blog: {
          href: '/blog',
          icon: this.option.icon,
        },
        cart: {
          href: '/cart',
          icon: 'mdi mdi-cart'
        }
      };
      return actions[this.option.action];
    },
  },
  methods: {
    setTarget(target) {
      if (target) return "_blank";
    },
  }
};
</script>

<style lang="scss" scoped>

.dropdown-item {

  &:hover {
    background: #f1f1f1;
  }
}
</style>
